export const LAST_GROUPS_KEY = "lastGroupId";
export const GROUPS_PATH = "groups";
export const MAX_RECENT_GROUPS = 5;
